const state = () => ({
  isValid: false,
  conditionsAgreement: '',
  privacyPolicy: '',
  medication: ''
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  conditionsAgreement(state) {
    return state.conditionsAgreement;
  },
  privacyPolicy(state) {
    return state.privacyPolicy;
  },
  medication(state) {
    return state.medication;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateConditionsAgreement(state, payload) {
    state.conditionsAgreement = payload;
  },
  updatePrivacyPolicy(state, payload) {
    state.privacyPolicy = payload;
  },
  updateMedication(state, payload) {
    state.medication = payload;
  },
  resetStore(s) {
    Object.assign(s, state());
  }
};

const actions = {
  updateConditionsAgreement({ commit }, payload) {
    commit('updateConditionsAgreement', payload);
  },
  updatePrivacyPolicy({ commit }, payload) {
    commit('updatePrivacyPolicy', payload);
  }
};

export const rsAssistantAgreements = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
